export default __webpack_public_path__ + "static/media/addImage.7e182752.svg";